import { FuturaLineaProformaFront } from '../../models/front-dto/api.dto';

export class SendClickEventEmitter {
    tabla: string;
    clicked: boolean;
    proformasToCreate: FuturaLineaProformaFront[] = [];
}
